<template>
    <v-dialog persistent v-model="get_dialogMain.dialog" width="800px" justify-center>
        <v-toolbar dense dark color="blue darken-2">
            <v-toolbar-title>
                <h3> Responder Encuenta</h3>
            </v-toolbar-title>
        <v-spacer></v-spacer>
            <v-btn icon dark @click="HIDDE_DIALOG_MAIN()">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>

    <v-card width="auto" tile>
            <v-card-text class="pa-4">
                <v-row dense>
                    <v-col cols="12" v-if="!toAnswer">
                      <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
                    </v-col>
                </v-row>
                <v-row dense v-if="toAnswer">
                  <h2>{{encuenta.nombre}}</h2>
                    <v-col cols="12">
                      <DinamicFormMain :formCreate="encuenta" :on-success="saveSurvey" :on-cancel="cancel" />
                    </v-col>
                </v-row>
            </v-card-text>
            <!--
            <v-card-actions>
                <v-layout justify-end>
                <v-btn class="red darken-1 mr-3" dark @click="cancel">Cancelar</v-btn>
                <v-btn class="green darken-1 mr-3" dark @click="save"> Guardar</v-btn>
                </v-layout>
            </v-card-actions>-->
    </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import DinamicFormMain from '@/components/forms/DinamicFormMain'
export default {
  props: ['model'],
  data: () => ({
    table: {
      header: {
        options: [],
        titles: [
          { text: 'Nombre', value: 'nombre', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Responder', icon: 'mdi-clipboard-text', color: 'lime lighten-1', action: 'toResponseSurvey', code: 'libre', hidden: '' }
        ]
      },
      footer: {
        paging: true
      }
    },
    period: {
      activo: 'si',
      fecha: new Date().toISOString().substr(0, 10)
    },
    encuenta: {
      preguntas: []
    },
    surveyResponse: {
      encuesta_id: 0,
      persona_id: 0,
      respuesta: []
    },
    toAnswer: false
  }),
  mounted () {
    if (this.model) {
      this.surveyResponse.persona_id = this.model.id
    }
    this.postUrl('period.listbydate')
  },
  components: {
    DataTableMain,
    DinamicFormMain
  },
  methods: {
    ...mapActions(['getUrlServices', 'postUrlServicesListActionSecound', 'postUrlServicesAction']),
    successAction (item) {
      this[item.action](item)
    },
    tableAction (item) {
      this[item.action](item)
    },
    toResponseSurvey (item) {
      this.encuenta = item.item
      this.surveyResponse.encuesta_id = item.item.id
      this.toAnswer = true
    },
    /* *==========*==========*==========*==========*==========* */
    postUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        // router.data = this.period
        this.postUrlServicesListActionSecound({ url: router, data: this.period })
      } else {
        this.getUrlServices()
      }
    },
    saveSurvey (model) {
      // console.log('saveSurvey', model)
      const router = this.get_urls['person.storerespuestas']
      this.surveyResponse.respuesta = model
      // console.log('saveSurvey', this.surveyResponse)
      this.postUrlServicesAction({ url: router, data: this.surveyResponse })
      this.toAnswer = true
    },
    save () {},
    cancel () {
      this.HIDDE_DIALOG_MAIN()
    },
    saveEncuesta (survey) {
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_objectsSecound', 'get_object'])
  },
  watch: {
    get_urls (val) {
      this.postUrl('period.listbydate')
    },
    get_object (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitos!',
        text: val.success
      })
      this.cancel()
    },
    get_objectsSecound (vals) {
      if (vals) {
        this.table.header.loading = false
        const survey = []
        vals.map(item => {
          survey.push(...item.encuestas)
        })
        this.table.body.data = survey
      }
    }
  }
}
</script>

<style>

</style>
